module.exports = __webpack_public_path__ + "img/Picture18.ccc4689b.png";